export default __webpack_public_path__ + "static/media/kiosk-trans-new-booking-system-sandb.6750757e.png";